module.exports = __webpack_public_path__ + "static/media/revert-grey.061ad233.svg";